var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "Report-gen" } },
    [
      _c(
        "IForm",
        {
          ref: "formInline",
          attrs: { "label-width": 150, model: _vm.edit, submit: false },
          on: { "on-submit": _vm.toSubmit },
        },
        [
          _c(
            "div",
            { attrs: { slot: "extend" }, slot: "extend" },
            [
              _c(
                "FormItem",
                { attrs: { label: "批量关联报告" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "95%" },
                      attrs: {
                        multiple: true,
                        filterable: true,
                        clearable: "",
                        placeholder: "请选择",
                      },
                      on: { change: _vm.relevance },
                      model: {
                        value: _vm.edit.batchReportId,
                        callback: function ($$v) {
                          _vm.$set(_vm.edit, "batchReportId", $$v)
                        },
                        expression: "edit.batchReportId",
                      },
                    },
                    _vm._l(_vm.reportList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        staticStyle: { width: "100%" },
                        attrs: { value: item.id, label: item.name },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._l(_vm.classList, function (classItem) {
                return _c(
                  "FormItem",
                  { attrs: { label: classItem.name } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "95%" },
                        attrs: {
                          multiple: true,
                          filterable: true,
                          clearable: "",
                          placeholder: "请选择",
                        },
                        on: {
                          change: (val) => _vm.classChoose(val, classItem),
                        },
                        model: {
                          value: _vm.edit[classItem.classId],
                          callback: function ($$v) {
                            _vm.$set(_vm.edit, classItem.classId, $$v)
                          },
                          expression: "edit[classItem.classId]",
                        },
                      },
                      _vm._l(_vm.reportList, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          staticStyle: { width: "100%" },
                          attrs: { value: item.id, label: item.name },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }